import ApiService from "service/Api";
import { HelpCenterPayloadTypes } from "utilities/types/HelpCenter";

const HelpCenterService = {
  getAllHelpCenters: async () => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/help-center",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeHelpCenter: async (payload: HelpCenterPayloadTypes) => {
    const { title, link, status } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        title: title,
        link: link,
        is_active: status,
      },
      url: "/admin/help-center",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateHelpCenter: async (
    helpCenterId: string,
    payload: HelpCenterPayloadTypes
  ) => {
    const { title, link, status } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        title: title,
        link: link,
        is_active: status,
        _method: "PUT",
      },
      url: "/admin/help-center/" + helpCenterId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteHelpCenter: async (helpCenterId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/help-center/" + helpCenterId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default HelpCenterService;
